import { render, staticRenderFns } from "./UploadCompressedFile.vue?vue&type=template&id=00b72d36&scoped=true"
import script from "./UploadCompressedFile.vue?vue&type=script&lang=js"
export * from "./UploadCompressedFile.vue?vue&type=script&lang=js"
import style0 from "./UploadCompressedFile.vue?vue&type=style&index=0&id=00b72d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b72d36",
  null
  
)

export default component.exports